import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

const components = {
  home: () => import('@/views/Home.vue'),
  productService: () => import('@/views/ProductService.vue'),
  assetManagementGang: () => import('@/views/assetManagementGang.vue'),
  environment: () => import('@/views/environment.vue'),
  food: () => import('@/views/food.vue'),
  engineering: () => import('@/views/engineering.vue'),
  quality: () => import('@/views/quality.vue'),
  customDevelopment: () => import('@/views/customDevelopment.vue'),
  customerService: () => import('@/views/CustomerService.vue'),
  customerCase: () => import('@/views/CustomerCase.vue'),
  aboutUs: () => import('@/views/AboutUs.vue'),
  privacyPolicy: () => import('@/views/PrivacyPolicy.vue'),
  aggrement: () => import('@/views/Aggrement.vue'),
  privacyPolicyZgb: () => import('@/views/PrivacyPolicyZgb.vue'),
  aggrementZgb: () => import('@/views/AggrementZgb.vue'),
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        title: '首页'
      },
      component: components.home
    },
    {
      path: '/productService',
      name: 'productService',
      meta: {
        title: '环测链'
      },
      component: components.productService,
    },
    {
      path: '/assetManagementGang',
      name: 'assetManagementGang',
      meta: {
        title: '资管帮'
      },
      component: components.assetManagementGang,
    },
    {
      path: '/environment',
      name: 'environment',
      meta: {
        title: '环境监测解决方案'
      },
      component: components.environment,
    },
    {
      path: '/food',
      name: 'food',
      meta: {
        title: '食品检测解决方案'
      },
      component: components.food,
    },
    {
      path: '/engineering',
      name: 'engineering',
      meta: {
        title: '建设工程质量检测解决方案'
      },
      component: components.engineering,
    },
    {
      path: '/quality',
      name: 'quality',
      meta: {
        title: '企业产品质量检测解决方案'
      },
      component: components.quality,
    },
    {
      path: '/customDevelopment',
      name: 'customDevelopment',
      meta: {
        title: '定制开发'
      },
      component: components.customDevelopment,
    },
    {
      path: '/customerService',
      name: 'customerService',
      meta: {
        title: '客户服务'
      },
      component: components.customerService,
    },
    {
      path: '/customerCase',
      name: 'customerCase',
      meta: {
        title: '客户案例'
      },
      component: components.customerCase,
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      meta: {
        // title:'关于我们'
      },
      component: components.aboutUs,
    },
    {
      path: '*',
      name: 'home',
      component: components.home
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: components.privacyPolicy
    },
    {
      path: '/aggrement',
      name: 'aggrement',
      component: components.aggrement
    },
    {
      path: '/privacyPolicyZgb',
      name: 'privacyPolicyZgb',
      component: components.privacyPolicyZgb
    },
    {
      path: '/aggrementZgb',
      name: 'aggrementZgb',
      component: components.aggrementZgb
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js